export default function getTimeZoneName() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
